import { Filter, FilterType } from '../filters';
import { GridSearchOptions } from '../utilities';
import dateTokeniser from './dateTokeniser';
import numberTokeniser from './numberTokeniser';
import textTokeniser from './textTokeniser';

export interface ApiTokeniser {
  tokeniseCondition: (item: any, property: string) => Token[];
}

export interface Token {
  key: string;
  value: string;
}

export function tokeniseCondition(item: Filter, property: string): { key: string; value: any }[] {
  const tokeniser = getTokeniser(item.filterType);
  if (tokeniser) {
    return tokeniser.tokeniseCondition(item, property);
  }

  return [];
}

export function getWrapWithItems(resolvedOptions: GridSearchOptions) {
  const wrapWithItems = [];
  wrapWithItems.push('count');
  if (resolvedOptions.wrapWith.totalCount) {
    wrapWithItems.push('total-count');
  }

  return wrapWithItems;
}

const getTokeniser: (filterType: FilterType) => ApiTokeniser = (filterType: FilterType) => {
  switch (filterType) {
    case 'text':
      return textTokeniser;
    case 'number':
      return numberTokeniser;
    case 'date':
      return dateTokeniser;
  }
};

export default getTokeniser;
